"use strict";
// @ts-ignore
try {
    self['workbox:cacheable-response:6.1.5'] && _();
}
catch (e) { }
